document.addEventListener('DOMContentLoaded', function() {
  const videoWrappers = document.querySelectorAll('.deferred-media__video-wrapper');

  videoWrappers.forEach(wrapper => {
    const button = wrapper.querySelector('[data-video-control]');
    if (!button) return;
    if (button.hasAttribute('data-listener-attached')) return;

    const videoType = button.getAttribute('data-video-type');
    const videoControlId = button.getAttribute('data-video-control');
    const pauseIcon = button.querySelector('.deferred-media__icon-pause');
    const playIcon = button.querySelector('.deferred-media__icon-play');
    const muteIcon = button.querySelector('.deferred-media__icon-mute');
    const soundIcon = button.querySelector('.deferred-media__icon-sound');

    const labels = {
      play: button.getAttribute('data-label-play') || 'Play video',
      pause: button.getAttribute('data-label-pause') || 'Pause video'
    };

    const nativeVideo = (videoType === 'shopify' || videoType === 'direct')
      ? wrapper.querySelector('video')
      : null;

      let state = {
      playing: false,
      muted: true,
      loaded: false
    };

    const isPlaying = () => (nativeVideo ? !nativeVideo.paused : state.playing);
    const isMuted = () => (nativeVideo ? nativeVideo.muted : state.muted);

    const updateUI = () => {
      const playing = isPlaying();

      if (pauseIcon) pauseIcon.style.display = playing ? 'block' : 'none';
      if (playIcon) playIcon.style.display = playing ? 'none' : 'block';
      button.setAttribute('aria-label', playing ? labels.pause : labels.play);
      wrapper.setAttribute('data-state', playing ? 'playing' : 'paused');

      const muted = isMuted();
      if (muteIcon) muteIcon.style.display = muted ? 'block' : 'none';
      if (soundIcon) soundIcon.style.display = muted ? 'none' : 'block';
    };

    const controllers = {
      native: {
        el: nativeVideo,
        play: function() { if (this.el) this.el.play(); },
        pause: function() { if (this.el) this.el.pause(); },
        mute: function() { if (this.el) this.el.muted = true; },
        unmute: function() { if (this.el) this.el.muted = false; }
      },
      youtube: {
        el: document.getElementById(videoControlId),
        msg: function(func, args = "") {
          if(!this.el || !this.el.contentWindow) return;
          this.el.contentWindow.postMessage(JSON.stringify({
            'event': 'command',
            'func': func,
            'args': [args] // Args must be an array for YT
          }), '*');
        },
        play: function() { this.msg('playVideo'); },
        pause: function() { this.msg('pauseVideo'); },
        mute: function() { this.msg('mute'); },
        unmute: function() { this.msg('unMute'); }
      },
      vimeo: {
        el: document.getElementById(videoControlId),
        msg: function(method, value) {
          if(!this.el || !this.el.contentWindow) return;
          this.el.contentWindow.postMessage(JSON.stringify({
            'method': method,
            'value': value
          }), '*');
        },
        play: function() { this.msg('play'); },
        pause: function() { this.msg('pause'); },
        mute: function() { this.msg('setVolume', 0); },
        unmute: function() { this.msg('setVolume', 1); }
      }
    };

    const activeController = nativeVideo ? controllers.native : controllers[videoType];
    if (!activeController) return;

    const togglePlay = () => {
      // For iframes, don't allow interaction until loaded
      if (!nativeVideo && !state.loaded) return;

      if (isPlaying()) {
        activeController.pause();
        state.playing = false;
      } else {
        activeController.play();
        state.playing = true;
      }
      updateUI();
    };

    const toggleMute = () => {
      if (!nativeVideo && !state.loaded) return;

      if (isMuted()) {
        activeController.unmute();
        state.muted = false;
      } else {
        activeController.mute();
        state.muted = true;
      }
      updateUI();
    };

    button.addEventListener('click', (e) => {
      if ((muteIcon && (e.target === muteIcon || muteIcon.contains(e.target)))
        || (soundIcon && (e.target === soundIcon || soundIcon.contains(e.target))))
      {
        toggleMute();
      } else {
        togglePlay();
      }
    });
    button.setAttribute('data-listener-attached', 'true');

    if (nativeVideo) {
      ['play', 'pause', 'volumechange'].forEach((evt) => {
        nativeVideo.addEventListener(evt, updateUI);
      });
      updateUI();
      return;
    }

    const iframe = document.getElementById(videoControlId);
    if (!iframe) return;

    wrapper.setAttribute('data-state', 'loading');

    const loadIframe = () => {
      const videoSrc = iframe.getAttribute('data-src');
      if (videoSrc && !iframe.src) {
        iframe.addEventListener('load', function() {
          state.loaded = true;
          activeController.play();
          state.playing = true;
          updateUI();
        }, { once: true });

        iframe.src = videoSrc;
      }
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadIframe();
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '50px' });

    observer.observe(wrapper);
  });
});
